
import { Image, StyleSheet, TouchableOpacity, View, useWindowDimensions } from "react-native";
import React, { useEffect, useRef, useState } from "react";

import { fp, hp, spH, spV, wp } from "utils/normalizeV2";


import BottomSheetModal from "../BottomSheetModal";
import { Colors } from "colors";
import { Images } from "assets";
import VText from "../VText";
import { useGlobalSearchParams } from "expo-router";

import Svg, { Circle, Path } from "react-native-svg";
const fileTypes = ["JPG", "PNG", "GIF"];
import DragAndDropFile from "./DragAndDropFile";
import Input from "components/Input";
import Buttons from "components/Buttons";



export default React.forwardRef((props, ref) => {

    const { onImageSelected } = props;
    const { height, width } = useWindowDimensions();
    const _bottomSheetRef = useRef();


    const [imageLink, setImageLink] = useState("");
    const [error, setError] = useState("");
    React.useImperativeHandle(ref, () => ({ show,hide }), []);

    const show = () => {
        _bottomSheetRef?.current?.show();
    };
    const hide = () => {
        _bottomSheetRef?.current?.hide();
        setImageLink("");
        setError("");
    }
    
    const handleImageUpload = (image) => {
        onImageSelected(image);
        _bottomSheetRef?.current?.hide();
    }

    const handleImageLink = () => {
        fetch(imageLink)
            .then(response => {
                if (response.ok && response.headers.get('Content-Type').includes('image')) {
                    handleImageUpload(imageLink);
                    setImageLink("");
                    setError("");
                } else {
                    setError("Invalid URL. Please enter a valid image URL.");
                }
            })
            .catch(() => {
                setError("Invalid URL. Please enter a valid image URL.");
            });
    }

    return (
        <BottomSheetModal
            MAX_HEIGHT_PERC={1}
            START_PERC={1}
            ref={_bottomSheetRef}
            hideLine
            containerStyle={{
                backgroundColor: "transparent",
                zIndex: 100,
            }}
        >
            <TouchableOpacity
                style={{
                    backgroundColor: "transparent",
                    width,
                    height,
                    alignItems: "center",
                    justifyContent: "center",
                    overflow: "hidden",
                    zIndex: 100,
                    cursor: "auto",
                }}
                activeOpacity={1}
                onPress={() => _bottomSheetRef?.current?.hide()}
            >
                
                <TouchableOpacity
                    style={{
                        width: wp(782),
                        height: hp(466),
                        height: "auto",
                        backgroundColor: "#fff",
                        borderRadius: 10,
                        
                        
                        cursor: "auto",
                    }}
                    activeOpacity={1}
                >
                    <TouchableOpacity
                        onPress={() => _bottomSheetRef?.current?.hide()}
                        activeOpacity={0.8}
                        style={{
                            position: "absolute",
                            right: 20,
                            top: 20,
                            zIndex: 100,
                        }}
                    >
                        <Svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <Circle cx="12" cy="12" r="12" fill="#F7F7F7" />
                            <Path
                                fillRule="evenodd"
                                clipRule="evenodd"
                                d="M11.4693 12.0006L7.75684 15.713L8.28717 16.2433L11.9996 12.5309L15.712 16.2433L16.2423 15.713L12.5299 12.0006L16.2423 8.28814L15.712 7.75781L11.9996 11.4702L8.28717 7.75781L7.75684 8.28814L11.4693 12.0006Z"
                                fill="#212427"
                            />
                        </Svg>
                    </TouchableOpacity>
                    

                    <View style={{ backgroundColor: "white", width:'100%', height: hp(461),borderRadius: 10, padding: spH(22) }}>
                        <VText style={{ fontSize: 20, fontWeight: "400", color: Colors.black, textAlign: "center", marginTop: spV(20), marginBottom: spV(20) }}> Search any image with Vêtir</VText>

                        <View style={{ backgroundColor: "#2124271A", borderRadius: 10, padding: spH(22) }}>
                            <DragAndDropFile  onFilesSelected={handleImageUpload} width={wp(738)} height={hp(150)} />


                            <View style={{flexDirection:"row",justifyContent:"space-between",alignItems:"center",width:wp(690),}} >
                                <View style={{borderTopWidth:1,borderColor:"#2124274D",width:wp(320),height:hp(8),justifyContent:"center",alignItems:"center"}}></View>
                                <VText style={{justifyContent:"center",alignItems:"center",fontSize:16}}> OR</VText>
                                <View style={{borderTopWidth:1,borderColor:"#2124274D",width:wp(320),height:hp(8),justifyContent:"center",alignItems:"center"}}></View>
                            </View>

                        <View style={{ flexDirection: "row", alignItems: "center", justifyContent: "center", marginTop: spV(20),marginBottom:spV(20) }}>
                            <Input
                                value={imageLink}
                                type="url"
                                onChangeText={setImageLink}
                                placeholder="Paste image link"
                                inputContainerStyle={{ flex: 1, marginRight: spH(10), backgroundColor: "#FFFFFF", borderWidth: 1, borderColor: "#000000",width:wp(600),borderRadius:30 }}
                            />
                            <Buttons
                                disabled={!imageLink}
                                onPress={handleImageLink}
                                text="Search"
                                containerStyle={{ backgroundColor: imageLink ? "#000000" : "#2124274D", padding: spH(10), borderRadius: 50,height:hp(50),width:wp(100),borderRadius:30 }}
                                textStyle={{ color: "#FFFFFF", fontSize: fp(16) }}
                            />
                        </View>
                        {error && <VText style={{ color: "red", fontSize: fp(13) }}>{error}</VText>}


                        </View>
                      
                       
                    </View>



                  


                </TouchableOpacity>
            </TouchableOpacity>
        </BottomSheetModal>
    );
});

const styles = StyleSheet.create({
    container: {
        backgroundColor: Colors.white,
        borderRadius: 8,
        width: wp(309),
    },
    image: {
        width: wp(309),
        height: hp(199),
    },
});
